const DESCRIPTION_MAX_CHARS = 90;

const truncateText = (text?: string, maxChars = DESCRIPTION_MAX_CHARS) => {
  if (!text) {
    return '';
  }

  const normalizedText = text.trim();
  if (normalizedText.length <= maxChars) {
    return normalizedText;
  }

  return `${normalizedText.slice(0, maxChars).trimEnd()}...`;
};

export {truncateText};
